export { default } from './Spot';
